import React from 'react';

const Label = props => (
  <label {...props} className="block cursor-pointer mb-1">{props.children}</label>
);

export default Label;